import React, { Component } from "react";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Header from "./common/header";
import Footer from "./common/footer";
import Home from "./pages/home";
import AboutUs from "./pages/about-us";
import Sitemap from "./pages/sitemap.js";
import LifeatNuvoco from "./pages/lifeatnuvoco";
// import OurJourney from "./pages/our-journey";
import Cement from "./pages/cement-plants";
import VisionMission from "./pages/vision-mission";
import BoardOfDirectors from "./pages/board-of-directors";
import ManagementTeam from "./pages/management-team";
import Product from "./pages/product";
import MBM from "./pages/mbm";
import ZeroMPartnership from "./pages/ZeroMPartnership";
import InstamixMortare from "./pages/instamix-mortare";
import CorporateGovernance from "./pages/corporate-governance";
import InvestorsCorner from "./pages/investors-corner";
import PerformanceHighlight from "./pages/performance-highlight";
import AnnualReports from "./pages/annul-reports";
import Media from "./pages/media";
import InnovationCentre from "./pages/innovation-centre";
import VadrajCement from "./pages/vadraj-cement";
import ScrollToTop from "./common/scrolltop";
import OurBarnd from "./pages/our-brand";
import JourneyV1 from "./pages/journey-v1";
// import JourneyV2 from "./pages/journey-v2";
import Governance from "./pages/governance.js"
import ContactUs from "./pages/contactUs";
import WOW from "wowjs";
import "./App.css";
import "./responsive.css";
import Blog from "./pages/blog";
import OurCement from "./pages/ourCement";
import OurMBM from "./pages/ourMBM";
import OurRMC from "./pages/ourRMC";
import Disclaimer from "./pages/disclaimer";
import Sustainability from "./pages/sustainability";
import Environment from "./pages/environment";
import GSTReform from "./pages/gstreform";
import Social from "./pages/social";
import HealthSafety from "./pages/health-and-safety";
import BrandStory from "./pages/our-brand-story";
import EVP from "./pages/our-employee-value-proposition";
import WomenInNuvoco from "./pages/press-releases/women-in-nuvoco";
import FinancialResultQ4FY22 from "./pages/press-releases/financial-result-q4-fy22";
import SolidifiesNorthIndia from "./pages/press-releases/solidifies-north-india";
import ConcretoGlyde from "./pages/press-releases/concreto-glyde";
import FinancialResultQ1FY23 from "./pages/press-releases/financial-result-q1-fy23";
import PlantinCoimbatore from "./pages/press-releases/plant-in-coimbatore";
import FinancialResultQ4FY23 from "./pages/press-releases/financial-result-q4-fy23";
import PlantinVizag from "./pages/press-releases/plant-in-vizag";
import AwardForExcellence2022 from "./pages/press-releases/award-for-excellence-2022";
import SwarnMahotsavinBihar from "./pages/press-releases/swarn-mahotsav-in-bihar";
import CommissioningofAFR from "./pages/press-releases/Commissioning-of-AFR-at-Risda-and-Nimbol";
import JojoberaCementPlant from "./pages/press-releases/Jojobera-Cement-Plant";
import FinancialResultQ2FY23 from "./pages/press-releases/financial-result-q2-fy23";
import NuvoNirmaanApp from "./pages/press-releases/Nuvo-Nirmaan-App";
import GreenProEcolabel from "./pages/press-releases/GreenPro-Ecolabel";
import SuperPremiumCement from "./pages/press-releases/Super-Premium-Cement";
import UltraModernAluminium from "./pages/press-releases/ultra-modern-aluminium";
import MasonSkillDevelopment from "./pages/press-releases/mason-skill-development";
import TechnicalMobileVan from "./pages/press-releases/technical-mobile-van";
import AFRProjectRisda from "./pages/press-releases/afr-project-Risda";
import InstaMixSuperiorConcrete from "./pages/press-releases/instaMix-superior-column-concrete";
import FinancialResultQ1FY24 from "./pages/press-releases/financial-result-q1-fy24";
import FibreReinforcedCement from "./pages/press-releases/fibre-reinforced-cement";
import DuraguardXtraJharkhand from "./pages/press-releases/duraguard-xtra-jharkhand";
import FinancialResultQ2FY24 from "./pages/press-releases/financial-result-q2-fy24";
import FinancialResultQ3FY24 from "./pages/press-releases/financial-result-q3-fy24";
import FinancialResultQ4FY24 from "./pages/press-releases/financial-result-q4-fy24";
import MasonSkillDevelopmentJamshedpur from "./pages/press-releases/mason-skill-development-Jamshedpur";
import ChittorCementPlant from "./pages/press-releases/chittor-cement-plant-success";
import ConcretoDawshomAwbotaar from "./pages/press-releases/concreto-with-dawshom-awbotaar";
import FootprintCuttingEdge from "./pages/press-releases/footprint-in-hyderabad-cutting-edge";
import ReadyMixPlantPatna from "./pages/press-releases/ready-mix-plant-Patna";
import StrengthensPresence from "./pages/press-releases/strengthens-presence-in-pune-mumbai";
import AnniversaryJojoberaPlant from "./pages/press-releases/anniversary-jojobera-cement-plant";
import BasantiDurgaPuja from "./pages/press-releases/shri-basanti-durga-puja";
import HydrophobicConcreteConcretoUno from "./pages/press-releases/hydrophobic-concrete-concreto-uno";
import NuvoMasonSkillDevelopmentCharkhi from "./pages/press-releases/nuvo-mason-skill-development-charkhi";
import EcodureThermalInsulatedConcrete from "./pages/press-releases/launch-ecodure-thermal-insulated-concrete";
import FinancialResultQ1FY25 from "./pages/press-releases/financial-result-q1-fy25";
import KeyLimestoneBlocks from "./pages/press-releases/key-limestone-blocks-at-competitive-rates";
import DuraguardSabseKhaasSarpanch from "./pages/press-releases/duraguard-sabse-khaas-sarpanch";
import UnveilsNuvoSetuApp from "./pages/press-releases/unveils-nuvo-setu-app";
import FinancialResultQ2FY25 from "./pages/press-releases/financial-result-q2-fy25";
import SuccessfulResolutionApplicant from "./pages/press-releases/successful-resolution-applicant";
import IntroducesZeroMTileAdhesiveT5 from "./pages/press-releases/introduces-zeroM-tile-adhesive-t5";
import UnveilsUniqueDuraguardMicrofiber from "./pages/press-releases/unveils-unique-duraguard-microfiber";
import MegaHealthCampManitara from "./pages/press-releases/mega-health-camp-at-manitara";
import EmbarksCraftingUniqueExperience from "./pages/press-releases/embarks-on-crafting-unique-experience";
import LaunchesNuvocoDuraguardMicrofiberCementinWesternUttarPradesh from "./pages/press-releases/launches-duraguard-microfiber-uttar-pradesh";
import NuvocoLaunchesSecondPlantNagpur from "./pages/press-releases/nuvoco-second-Ready-mix-plant-Nagpur";
import NuvocoLaunchesSecondPlantRanchi from "./pages/press-releases/nuvoco-second-Ready-mix-plant-ranchi";
import ZeroDropoutDriveUnderShikshitBharatProgram from "./pages/press-releases/zero-dropout-drive-under-shikshit-bharat-program";
import FinancialResultQ3FY25 from "./pages/press-releases/financial-result-q3-fy25";
import SabseKhaasPehelwaanHUWC from "./pages/press-releases/sabse-khaas-pehelwaan-HUWC";
import NCLTAcquireVadrajCement from "./pages/press-releases/nclt-acquire-vadrajcement";
import FinancialResultQ4FY25 from "./pages/press-releases/financial-result-q4-fy25";
import SabseKhaasPehelwaanFinaleDelhi from "./pages/press-releases/sabse-khaas-pehelwaan-finale-delhi";
import RisdaCementPlantMinesExpansion from "./pages/press-releases/risda-cement-plant-mines-expansion";
import NuvomasonSkillDevelopmentProgramPanagarh from "./pages/press-releases/nuvo-mason-skill-development-program-panagarh";
import AssistantMasonTrainingProgramJamshedpur from "./pages/press-releases/assistant-mason-training-program-jamshedpur";
import SabseKhaasSarpanchCampaignChhattisgarh from "./pages/press-releases/sabse-khaas-sarpanch-campaign-chhattisgarh";
import FinancialResultQ1FY26 from "./pages/press-releases/financial-result-q1-fy26";
import SocialForestryProjectSamutola from "./pages/press-releases/social-forestry-project-samutola";
import LaunchesMobileMedicalVan from "./pages/press-releases/launches-mobile-medical-van";
import NimbolCementPlantFelicitatesStudents from "./pages/press-releases/nimbol-cement-plant-felicitates-students";

import { Helmet } from "react-helmet";
import HirenPatel from "./pages/board-of-director/hiren-patel";
import KaushikbhaiPatel from "./pages/board-of-director/Kaushikbhai-Patel";
import BhavnaDoshi from "./pages/board-of-director/Bhavna-Doshi";
import BerjisDesai from "./pages/board-of-director/Berjis-Desai";
import AchalBakeri from "./pages/board-of-director/Achal-Bakeri";
import JayakumarKrishnaswamy from "./pages/board-of-director/Jayakumar-Krishnaswamy";
import ShrutaSanghavi from "./pages/board-of-director/Shruta-Sanghavi";
import MananShah from "./pages/board-of-director/Manan-Shah";
import MadhumitaBasu from "./pages/board-of-director/Madhumita-Basu";
import i18nRoutes from "./i18n.routes";
import LanguageHandler from "./common/languageHandler";
import KnowledgePanel from "./pages/knowledgepanel";
const PageNotFound = () => {
  return (
    <div style={{ padding: "100px 20px", textAlign: "center", minHeight: "60vh" }}>
      <h1 style={{ fontSize: "72px", color: "#e31e24" }}>404</h1>
      <h2>Oops! Page Not Found</h2>
      <p>The page you are looking for might have been removed or is temporarily unavailable.</p>
      <Link to="/" className="btn" style={{ marginTop: "20px", display: "inline-block", background: "#e31e24", color: "#fff", padding: "10px 25px", borderRadius: "5px" }}>
        Back to Home
      </Link>
    </div>
  );
};
class App extends Component {
  componentDidMount() {
    const suppressResizeObserverError = e => {
      if (e.message?.includes('ResizeObserver loop completed with undelivered notifications.') ||
        e.message?.includes('ResizeObserver loop limit exceeded')) {
        const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay-div');
        const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');
        if (resizeObserverErr) resizeObserverErr.style.display = 'none';
        if (resizeObserverErrDiv) resizeObserverErrDiv.style.display = 'none';
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    };
    window.addEventListener('error', suppressResizeObserverError);
    window.addEventListener('unhandledrejection', e => {
      if (e.reason?.message?.includes('ResizeObserver loop')) {
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    });

    new WOW.WOW({
      live: false,
    }).init();
  }


  render() {
    return (
      <Router>
        <ScrollToTop />
        <Header />
        <Helmet>
          <title>
            Best Cement Company | Cement Suppliers Near Me - Nuvoco Vistas
          </title>

          <meta
            name="description"
            content="Nuvoco Vistas is one of the leading cement suppliers in India and rated as one of the best cement dealers and manufacturers. It has cement plants across major parts of India."
          />
        </Helmet>
        <Routes>
          <Route element={<LanguageHandler />}>
            <Route path="/" element={<Home />}></Route>
            <Route path="/about-us" element={<AboutUs />}></Route>
            <Route path="life-at-nuvoco" element={<LifeatNuvoco />}></Route>
            <Route path="our-journey" element={<JourneyV1 />}></Route>

            <Route path="cement-plants/:location" element={<Cement />}></Route>
            <Route path="knowledge-panel" element={<KnowledgePanel />}></Route>
            <Route
              path="vision-mission-and-values"
              element={<VisionMission />}
            ></Route>
            <Route
              path="quality-and-innovation"
              element={<InnovationCentre />}
            ></Route>
            <Route path="vadrajcement" element={<VadrajCement />}></Route>
             <Route path="vadrajcement" element={<PageNotFound />}></Route>
            <Route
              path="board-of-directors"
              element={<BoardOfDirectors />}
            ></Route>
            <Route path="management-team" element={<ManagementTeam />}></Route>
            <Route
              path="products/:cementconcreto"
              element={<Product />}
            ></Route>
            <Route path="mbm" element={<MBM />}></Route>
            <Route
              path="instamix-mortare"
              element={<InstamixMortare />}
            ></Route>
            <Route
              path="corporate-governance"
              element={<CorporateGovernance />}
            ></Route>
            <Route
              path="investors-corner"
              element={<InvestorsCorner />}
            ></Route>
            <Route
              path="performance-highlights"
              element={<PerformanceHighlight />}
            ></Route>
            <Route path="media/:type" element={<Media />}></Route>
            <Route path="our-brands" element={<OurBarnd />}></Route>
            <Route path="contact-us" element={<ContactUs />}></Route>
            <Route path="gstreform" element={<GSTReform />}></Route>
            <Route path="annual-reports" element={<AnnualReports />}></Route>
            <Route path="blog/:blog" element={<Blog />}></Route>
            <Route path="hindi/blog/:blog" element={<Blog />}></Route>
            <Route path="gujarati/blog/:blog" element={<Blog />}></Route>
            <Route path="marathi/blog/:blog" element={<Blog />}></Route>
            <Route path="top-cement-company" element={<OurCement />}></Route>
            <Route
              path="modern-building-materials"
              element={<OurMBM />}
            ></Route>{" "}
            <Route
              path="nuvoco-zero-m-partner"
              element={<ZeroMPartnership />}
            ></Route>
            <Route path="ready-mix-concrete" element={<OurRMC />}></Route>
            <Route path="disclaimer" element={<Disclaimer />}></Route>
            <Route path="governance" element={<Governance />}></Route>
            {/* <Route path="governance" element={<PageNotFound />}></Route> */}


            <Route path="sustainability" element={<Sustainability />}></Route>
            <Route path="environment" element={<Environment />}></Route>
            <Route path="social" element={<Social />}></Route>
            <Route path="health-and-safety" element={<HealthSafety />}></Route>
            <Route path="our-brand-story" element={<BrandStory />}></Route>
            <Route
              path="our-employee-value-proposition"
              element={<EVP />}
            ></Route>
            {/* Press Releases */}
            <Route
              path="media/:type/women-in-nuvoco"
              element={<WomenInNuvoco />}
            ></Route>
            <Route
              path="media/:type/financial-result-q4-fy22"
              element={<FinancialResultQ4FY22 />}
            ></Route>
            <Route
              path="media/:type/solidifies-position-in-north-india"
              element={<SolidifiesNorthIndia />}
            ></Route>
            <Route
              path="media/:type/concreto-glyde"
              element={<ConcretoGlyde />}
            ></Route>
            <Route
              path="media/:type/financial-result-q1-fy23"
              element={<FinancialResultQ1FY23 />}
            ></Route>
            <Route
              path="media/:type/plant-in-coimbatore"
              element={<PlantinCoimbatore />}
            ></Route>
            <Route
              path="media/:type/financial-result-q4-fy23"
              element={<FinancialResultQ4FY23 />}
            ></Route>
            <Route
              path="media/:type/plant-in-vizag"
              element={<PlantinVizag />}
            ></Route>
            <Route
              path="media/:type/award-for-excellence-2022"
              element={<AwardForExcellence2022 />}
            ></Route>
            <Route
              path="media/:type/swarn-mahotsav-in-bihar"
              element={<SwarnMahotsavinBihar />}
            ></Route>
            <Route
              path="media/:type/Commissioning-of-AFR-at-Risda-and-Nimbol"
              element={<CommissioningofAFR />}
            ></Route>
            <Route
              path="media/:type/Jojobera-Cement-Plant"
              element={<JojoberaCementPlant />}
            ></Route>
            <Route
              path="media/:type/financial-result-q2-fy23"
              element={<FinancialResultQ2FY23 />}
            ></Route>
            <Route
              path="media/:type/Nuvo-Nirmaan-App"
              element={<NuvoNirmaanApp />}
            ></Route>
            <Route
              path="media/:type/GreenPro-Ecolabel"
              element={<GreenProEcolabel />}
            ></Route>
            <Route
              path="media/:type/Super-Premium-Cement"
              element={<SuperPremiumCement />}
            ></Route>
            <Route
              path="media/:type/ultra-modern-aluminium"
              element={<UltraModernAluminium />}
            ></Route>
            <Route
              path="media/:type/mason-skill-development"
              element={<MasonSkillDevelopment />}
            ></Route>
            <Route
              path="media/:type/technical-mobile-van"
              element={<TechnicalMobileVan />}
            ></Route>
            <Route
              path="media/:type/afr-project-Risda"
              element={<AFRProjectRisda />}
            ></Route>
            <Route
              path="media/:type/instaMix-superior-column-concrete"
              element={<InstaMixSuperiorConcrete />}
            ></Route>
            <Route
              path="media/:type/financial-result-q1-fy24"
              element={<FinancialResultQ1FY24 />}
            ></Route>
            <Route
              path="media/:type/fibre-reinforced-cement"
              element={<FibreReinforcedCement />}
            ></Route>
            <Route
              path="media/:type/duraguard-xtra-jharkhand"
              element={<DuraguardXtraJharkhand />}
            ></Route>
            <Route
              path="media/:type/financial-result-q2-fy24"
              element={<FinancialResultQ2FY24 />}
            ></Route>
            <Route
              path="media/:type/financial-result-q3-fy24"
              element={<FinancialResultQ3FY24 />}
            ></Route>
            <Route
              path="media/:type/mason-skill-development-Jamshedpur"
              element={<MasonSkillDevelopmentJamshedpur />}
            ></Route>
            <Route
              path="media/:type/chittor-cement-plant-success"
              element={<ChittorCementPlant />}
            ></Route>
            <Route
              path="media/:type/concreto-with-dawshom-awbotaar"
              element={<ConcretoDawshomAwbotaar />}
            ></Route>
            <Route
              path="media/:type/footprint-in-hyderabad-cutting-edge"
              element={<FootprintCuttingEdge />}
            ></Route>
            <Route
              path="media/:type/ready-mix-plant-Patna"
              element={<ReadyMixPlantPatna />}
            ></Route>
            <Route
              path="media/:type/strengthens-presence-in-pune-mumbai"
              element={<StrengthensPresence />}
            ></Route>
            <Route
              path="media/:type/anniversary-jojobera-cement-plant"
              element={<AnniversaryJojoberaPlant />}
            ></Route>
            <Route
              path="media/:type/shri-basanti-durga-puja"
              element={<BasantiDurgaPuja />}
            ></Route>
            <Route
              path="media/:type/financial-result-q4-fy24"
              element={<FinancialResultQ4FY24 />}
            ></Route>
            <Route
              path="media/:type/hydrophobic-concrete-concreto-uno"
              element={<HydrophobicConcreteConcretoUno />}
            ></Route>
            <Route
              path="media/:type/nuvo-mason-skill-development-charkhi"
              element={<NuvoMasonSkillDevelopmentCharkhi />}
            ></Route>
            <Route
              path="media/:type/launch-ecodure-thermal-insulated-concrete"
              element={<EcodureThermalInsulatedConcrete />}
            ></Route>
            <Route
              path="media/:type/financial-result-q1-fy25"
              element={<FinancialResultQ1FY25 />}
            ></Route>
            <Route
              path="media/:type/key-limestone-blocks-at-competitive-rates"
              element={<KeyLimestoneBlocks />}
            ></Route>
            <Route
              path="media/:type/duraguard-sabse-khaas-sarpanch"
              element={<DuraguardSabseKhaasSarpanch />}
            ></Route>
            <Route
              path="media/:type/unveils-nuvo-setu-app"
              element={<UnveilsNuvoSetuApp />}
            ></Route>
            <Route
              path="media/:type/financial-result-q2-fy25"
              element={<FinancialResultQ2FY25 />}
            ></Route>
            <Route
              path="media/:type/successful-resolution-applicant"
              element={<SuccessfulResolutionApplicant />}
            ></Route>
            <Route
              path="media/:type/introduces-zeroM-tile-adhesive-t5"
              element={<IntroducesZeroMTileAdhesiveT5 />}
            ></Route>
            <Route
              path="media/:type/unveils-unique-duraguard-microfiber"
              element={<UnveilsUniqueDuraguardMicrofiber />}
            ></Route>
            <Route
              path="media/:type/mega-health-camp-at-manitara"
              element={<MegaHealthCampManitara />}
            ></Route>
            <Route
              path="media/:type/embarks-on-crafting-unique-experience"
              element={<EmbarksCraftingUniqueExperience />}
            ></Route>
            <Route
              path="media/:type/launches-duraguard-microfiber-uttar-pradesh"
              element={
                <LaunchesNuvocoDuraguardMicrofiberCementinWesternUttarPradesh />
              }
            ></Route>
            <Route
              path="media/:type/nuvoco-second-Ready-mix-plant-Nagpur"
              element={<NuvocoLaunchesSecondPlantNagpur />}
            ></Route>
            <Route
              path="media/:type/nuvoco-second-Ready-mix-plant-ranchi"
              element={<NuvocoLaunchesSecondPlantRanchi />}
            ></Route>
            <Route
              path="media/:type/zero-dropout-drive-under-shikshit-bharat-program"
              element={<ZeroDropoutDriveUnderShikshitBharatProgram />}
            ></Route>
            <Route
              path="media/:type/financial-result-q3-fy25"
              element={<FinancialResultQ3FY25 />}
            ></Route>
            <Route
              path="media/:type/sabse-khaas-pehelwaan-HUWC"
              element={<SabseKhaasPehelwaanHUWC />}
            ></Route>
            <Route
              path="media/:type/nclt-acquire-vadrajcement"
              element={<NCLTAcquireVadrajCement />}
            ></Route>
            <Route
              path="media/:type/financial-result-q4-fy25"
              element={<FinancialResultQ4FY25 />}
            ></Route>
            <Route
              path="media/:type/sabse-khaas-pehelwaan-finale-delhi"
              element={<SabseKhaasPehelwaanFinaleDelhi />}
            ></Route>
            <Route
              path="media/:type/risda-cement-plant-mines-expansion"
              element={<RisdaCementPlantMinesExpansion />}
            ></Route>
            <Route
              path="media/:type/nuvo-mason-skill-development-program-panagarh"
              element={<NuvomasonSkillDevelopmentProgramPanagarh />}
            ></Route>
            <Route
              path="media/:type/assistant-mason-training-program-jamshedpur"
              element={<AssistantMasonTrainingProgramJamshedpur />}
            ></Route>
            <Route
              path="media/:type/sabse-khaas-sarpanch-campaign-chhattisgarh"
              element={<SabseKhaasSarpanchCampaignChhattisgarh />}
            ></Route>
            <Route
              path="media/:type/financial-result-q1-fy26"
              element={<FinancialResultQ1FY26 />}
            ></Route>
            <Route
              path="media/:type/social-forestry-project-samutola"
              element={<SocialForestryProjectSamutola />}
            ></Route>
            <Route
              path="media/:type/launches-mobile-medical-van"
              element={<LaunchesMobileMedicalVan />}
            ></Route>
            <Route
              path="media/:type/nimbol-cement-plant-felicitates-students"
              element={<NimbolCementPlantFelicitatesStudents />}
            ></Route>
            {/* Board of Directors */}
            <Route path="hiren-patel" element={<HirenPatel />}></Route>
            <Route
              path="Kaushikbhai-Patel"
              element={<KaushikbhaiPatel />}
            ></Route>
            <Route path="Bhavna-Doshi" element={<BhavnaDoshi />}></Route>
            <Route path="Berjis-Desai" element={<BerjisDesai />}></Route>
            <Route path="Achal-Bakeri" element={<AchalBakeri />}></Route>
            <Route
              path="Jayakumar-Krishnaswamy"
              element={<JayakumarKrishnaswamy />}
            ></Route>
            <Route path="Shruta-Sanghavi" element={<ShrutaSanghavi />}></Route>
            <Route path="Manan-Shah" element={<MananShah />}></Route>
            <Route path="Madhumita-Basu" element={<MadhumitaBasu />}></Route>
            <Route path="/sitemap" element={<Sitemap />}></Route>
          </Route>
          {/* i18n Routes */}
          <Route path="/:lng" element={<LanguageHandler />}>
            {i18nRoutes}
          </Route>
          <Route path="*" element={<PageNotFound />} />
        </Routes>
        <Footer />
      </Router>
    );
  }
}

export default App;
